<h1 mat-dialog-title>CARICA NUOVO DOCUMENTO<mat-icon class="close-icon" (click)="onNoClick()">close</mat-icon>
</h1>

<div class="form-container">
  <form class="details-form" enctype="multipart/form-data">



    <mat-form-field class="full-width-textarea">
      <mat-label>Descrizione*</mat-label>
      <textarea rows="5" matInput placeholder="Descrizione" [value]="data.details.descrizione" name="descrizione"
                [(ngModel)]="data.details.descrizione"></textarea>
    </mat-form-field>

    <mat-form-field class="half-width">

      <mat-label>Data*</mat-label>

      <input matInput [matDatepicker]="documento" placeholder="Data decreto" name="documento"
             [(ngModel)]="data.details.dtCaricamento">

      <mat-datepicker-toggle matIconSuffix [for]="documento"></mat-datepicker-toggle>
      <mat-datepicker #documento></mat-datepicker>

    </mat-form-field>

    <input type="file" id="file" name="file" class="file-upload full-width"
           (change)="onFileSelected($event,data.details.idAreaCaricamento)" placeholder="Seleziona il file" accept=".pdf">

    <p class="decreto" *ngIf="data.details.idDocumento && data.details.idDocumento!=''"
       (click)="downloadDecreto(data.details.idDocumento)">
      <mat-icon>download</mat-icon><span>Id Documento: {{data.details.idDocumento}}</span>
    </p>
  </form>
</div>
<div mat-dialog-actions class="actions">
  <button mat-fab extended class="searchbox-buttons ripristina-button" (click)="onNoClick()">
    <mat-icon>close</mat-icon>Chiudi
  </button>
  <button mat-fab extended class="searchbox-buttons save-button"
          [disabled]="checkForm()" [mat-dialog-close]="data" (click)="save()">
    <mat-icon>save</mat-icon>Salva
  </button>
</div>
